import React from 'react';
import GridMenu from '../Menu/GridMenu';
import './HomeEyeCheckUp.scss';

const HomeEyeCheckUp = props => {
    const { updateNavDtm, parentMenu, menuData, section, cta } = props;
    const parentKey = Object.keys(parentMenu).toString();
    const fetchMenu = menuData.data.map((data, index) => {
        return (
            <div className={`home-eye-checkup ${section.replace(/ /g, '').replace(/-/g, '').toLowerCase()}`} key={index}>
                {parentMenu[parentKey] && parentMenu[parentKey].sliderType ?
                    <div className="layout justify-content-around text-black no-decoration">
                        <div className="checkup-image-section">
                            <img src={data.image.src} alt={data.image.imgAlt} />
                        </div>
                        <div className="margin-l35 right-content">
                            <h4 className="heading-text">
                                {data.headingText}
                            </h4>
                            <p className="lh-20 support-text margin-b15">{data.supportText}</p>
                            {data.sliderImg && <GridMenu menuData={data.sliderImg} parentMenu={parentMenu[parentKey]} updateNavDtm={updateNavDtm} section={section} />}
                            {data.boldText && <h5 className="light-dark margin-b15">
                                {data.boldText}
                            </h5>}
                            <button className="btn btn-navigation" onClick={() => updateNavDtm(section)}><a href={data.url}>{data.buttonText}</a></button>
                        </div>
                    </div> :
                        <a
                            href={data.url}
                            onClick={() => updateNavDtm(section, null, null, null, cta)}
                            className="layout justify-content-around text-black no-decoration"
                        >
                        <div className="checkup-image-section">
                            <img src={data.image.src} alt={data.image.imgAlt} />
                        </div>
                        <div className="margin-l35 right-content">
                            <h4 className="heading-text">
                                {data.headingText}
                            </h4>
                            <p className="lh-20 support-text margin-b15">{data.supportText}</p>
                            {data.boldText && <h5 className="light-dark margin-b15">
                                {data.boldText}
                            </h5>}
                            <button className="btn btn-navigation">{data.buttonText}</button>
                        </div>
                        </a>
                    }
            </div>
        );
    });
    return (
        <div className="nav-level-acc">{fetchMenu}</div>
    );
};

HomeEyeCheckUp.defaultProps = {
    parentMenu: {}
};

export default HomeEyeCheckUp;
